import React from "react";
import styles from "./cardStack.module.scss";
import cardImg from "../../assests/virtualCard.png";
import virtualImg from "../../assests/vitualdesignImg.png.png";
import webHostingImg from "../../assests/webHostingImg.png";
import cloudImg from "../../assests/cloudsupportImg.png";
import databaseImg from "../../assests/databaseImg.png";

const cardData = [
  {
    id: 1,
    image: virtualImg,
    title: "Virtual machine",
    description:
      "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  },
  {
    id: 2,
    image: databaseImg,
    title: "Database",
    description:
      "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  },
  {
    id: 3,
    image: webHostingImg,
    title: "Web Hosting",
    description:
      "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  },
  {
    id: 4,
    image: cloudImg,
    title: "Cloud Support",
    description:
      "We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.We will provide a server in your home our technical team will come to your site and fix the server for your data base needed it will more help for your cost optimization and data base theft production.",
  },
];

const CardStack = () => {
  return (
    <div className={styles.container}>
      <div className={styles.wrapper}>
        <div className={styles.heading}>Services that we offer</div>
        <div className={styles.cardWrapper}>
          {cardData.map((item, index) => (
            <div
              key={item.id}
              className={`${styles.card} ${styles[`card${index + 1}`]}`}
            >
              <div className={styles.inner}>
                <div className={styles.front}>
                  <img src={cardImg} alt="" className={styles.cardImg} />
                </div>
                <div className={styles.back}>
                  <div className={styles.backContent}>
                    <div className={styles.imageContainer}>
                      <img src={item.image} alt="" className={styles.image} />
                    </div>
                    <div className={styles.title}>{item.title}</div>
                    <div className={styles.description}>{item.description}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className={styles.mobileCardWrapper}>
          {cardData.map((item, index) => (
            <div key={item.id} className={styles.card}>
              <div className={styles.content}>
                <div className={styles.imageContainer}>
                  <img src={item.image} alt="" className={styles.image} />
                </div>
                <div className={styles.title}>{item.title}</div>
                <div className={styles.description}>{item.description}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default CardStack;
